import React from 'react';
import ManagerLayout from '../../components/manager/ManagerLayout';
import { OwnerOutreachPage } from '../shared/OwnerOutreachPage';

const ManagerOwnerOutreachPage: React.FC = () => {
  return (
    <ManagerLayout>
      <OwnerOutreachPage mode="manager" />
    </ManagerLayout>
  );
};

export default ManagerOwnerOutreachPage;
